import React from 'react';
// import {SpinnerContainer,SpinnerOverlay} from './with-spinner.styles'
import './s.styles.css'
const WithSpinner = () => (
            <div className="SpinnerOverlay">
                <div className="SpinnerContainer"/>
            </div>
    
);
export default WithSpinner;